// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
window.bootstrap = require('bootstrap')
import './main/styles.scss'
import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "controllers"
import '@tabler/core/dist/js/tabler'
import '@tabler/core/dist/css/tabler'

Rails.start()
ActiveStorage.start()

